import { css, StyleSheet } from "aphrodite";

import { calculateBusinessHours } from "~/utils/AgentUtils";
import { COLORS } from "~/config/themes";

const OpenAt = ({ hours, highlight, timezone, preCalculatedHours }) => {
  // Use pre-calculated hours if provided (from SSR), otherwise calculate client-side
  const businessHours = preCalculatedHours || calculateBusinessHours({
    hours,
    timezone,
  });

  const { times, closed, noTimes } = businessHours;

  return (
    <>
      {!noTimes && (
        <div className={css(styles.responseInfo)}>
          <div className={css(styles.greenDotContainer)}>
            <div className={css(styles.greenDot, closed && styles.redDot)} />
          </div>
          <span className={css(styles.responseText)}>
            {closed ? "Closed " : "Open "}
            <span
              className={css(
                styles.responseHighlight,
                highlight,
                closed && styles.closed
              )}
            >
              {times}
            </span>
          </span>
        </div>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  responseInfo: {
    marginRight: 28,
    display: "flex",
    alignItems: "center",
    "@media only screen and (max-width: 1023px)": {
      marginRight: 16,
    },
  },
  greenDotContainer: {
    width: 15,
    height: 15,
    display: "flex",
    alignItems: "center",
    paddingLeft: 2,
    boxSizing: "border-box",
  },
  greenDot: {
    background: COLORS.GREEN(),
    width: 10,
    height: 10,
    borderRadius: "100%",
  },
  redDot: {
    background: COLORS.THERMO_RED(),
  },
  responseHighlight: {
    color: COLORS.GREEN(),
  },
  responseText: {
    fontSize: 15,
    lineHeight: "24px",
    fontWeight: 400,
    marginLeft: 8,

    "@media only screen and (max-width: 1023px)": {
      marginLeft: 6,
    },
  },
  closed: {
    color: COLORS.THERMO_RED(),
  },
});
export default OpenAt;
